/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable camelcase */
import dutchMessages from 'ra-language-dutch'
import { StringMap } from 'react-admin'

export const i18nDutch: StringMap = {
  ...dutchMessages,
  dashboard: {
    greeting: {
      morning: 'Goedemorgen',
      afternoon: 'Goedemiddag',
      evening: 'Goedenavond',
    },
    description: 'Welkom bij xxllnc Prognoses.',
    descriptionAdmin: 'Welkom bij xxllnc Prognoses.',
  },
  resources: {
    gemeenten: {
      name: 'Gemeente |||| Gemeenten',
      list: 'Gemeenten',
      create: 'Gemeente toevoegen',
      edit: 'Gemeente bewerken',
      show: 'Gemeente details',
    },
    prognose_sets: {
      name: 'Stadsprognose |||| Stadsprognoses',
      list: 'Stadsprognoses',
      create: 'Stadsprognose aanmaken',
      edit: 'Stadsprognose bewerken',
    },
    gebiedsprognoses: {
      name: 'Gebiedsprognose |||| Gebiedsprognoses',
      list: 'Gebiedsprognoses',
      create: 'Gebiedsprognose aanmaken',
      edit: 'Gebiedsprognose bewerken',
    },
    historische_data: {
      name: 'Historische data',
      list: 'Historische data',
    },
    historische_data_stad: {
      name: 'Stad',
      list: 'Historische data — Stad',
    },
    historische_data_gebied: {
      name: 'Gebied',
      list: 'Historische data — Gebied',
    },
    overige_data: {
      name: 'Overige data',
      list: 'Overige data',
    },
    overige_data_stad: {
      name: 'Stad',
      list: 'Overige data — Stad',
    },
    overige_data_gebied: {
      name: 'Gebied',
      list: 'Overige data — Gebied',
    },
  },
  filters: {
    title: 'Filters',
    status: 'Status',
    all: 'Alles',
  },
  data: {
    naam: 'Naam',
    gm_code: 'Gemeentecode',
    gm_naam: 'Gemeente',
    provincie: 'Provincie',
    corop: 'COROP-regio',
    type: 'Type',
    status: 'Status',
    hjaar: 'Startjaar',
    bjaar: 'Basisjaar',
    ejaar: 'Eindjaar',
    parameters: 'Parameters',
    resultaat: 'Resultaat',
    omschrijving: 'Omschrijving',
    publicatie_status: 'Publicatiestatus',
    categorie: 'Categorie',
    geslacht: 'Geslacht',
    leeftijd: 'Leeftijd',
    jaar: 'Jaar',
    waarde: 'Waarde',
  },
  historische_data: {
    title: 'Historische data',
    geen_data: 'Geen historische data gevonden voor deze selectie.',
    selecteer_gemeente: 'Selecteer een gemeente om historische data te bekijken.',
    import_titel: 'Data importeren',
    export_titel: 'Data exporteren',
    categorieen: {
      pop: 'Bevolking',
      geb: 'Geboorte',
      ste: 'Sterfte',
      ves: 'Vestiging',
      ver: 'Vertrek',
      won: 'Woningvoorraad',
      hh: 'Huishoudens',
      imi: 'Binnenlandse vestiging',
      imu: 'Buitenlandse vestiging',
      emi: 'Binnenlands vertrek',
      emu: 'Buitenlands vertrek',
    },
  },
  prognose: {
    status: {
      concept: 'Concept',
      definitief: 'Definitief',
      archief: 'Archief',
    },
    bewerken: 'Prognose bewerken',
    verwijderen: 'Prognose verwijderen',
    verwijderen_bevestiging: 'Weet je zeker dat je deze prognose wilt verwijderen?',
    excel_export: 'Excel export',
  },
  settings: {
    title: 'Instellingen',
    saved: 'Instellingen opgeslagen',
    cbs: {
      title: 'CBS Data ophalen',
      description:
        'Download een ZIP met CBS-data voor de geselecteerde gemeente. '
        + 'Per dataset wordt een xlsx-bestand toegevoegd, gefilterd op de '
        + 'gemeente en optioneel op jaren. Landelijke referentie-datasets '
        + 'worden ongefilterd opgenomen.',
      gemeente: 'Gemeente',
      jaren: 'Jaren',
      jaren_placeholder: 'bijv. 2018,2019,2020',
      jaren_help: 'Comma gescheiden. Leeg = alle jaren.',
      toon_info: 'Voeg info-tabblad toe per dataset',
      download_button: 'Downloaden',
      building_zip: 'ZIP wordt opgebouwd…',
      error: 'Download mislukt: %{message}',
    },
  },
  login: {
    title: 'Inloggen',
    button: 'Inloggen',
    choose: 'Kies voor welke organisatie je wilt inloggen:',
    email: 'Email',
    emailHint: 'Vul je emailadres in om door te gaan.',
    fetchUserInfo: 'Een moment geduld, we halen je gebruikersinformatie op.',
    hint: 'Log in op xxllnc Prognoses',
    incognitoError: 'Authenticatie niet mogelijk in incognito mode',
    loginCompleted: 'Succesvol ingelogd!',
    unknownOrganizationId: 'Het opgegeven organisatie-id is onbekend',
    notValid: 'Het opgegeven emailadres is niet geldig',
    byXxllnc: 'Prognoses is een applicatie van xxllnc',
    inactive: 'Je bent uitgelogd vanwege inactiviteit.',
  },
  page: {
    unauthorized: {
      headerTitle: 'Onbevoegd',
      defaultTitle: 'Onbevoegd',
      title: 'Voor deze actie ben je niet bevoegd.',
      text: 'Je hebt geprobeerd een actie uit te voeren waar je geen rechten voor hebt.',
    },
  },
  actions: {
    download: 'Download',
  },
  submenu: {
    historische_data: 'Historische data',
    prognoses: 'Prognoses',
    overige_data: 'Overige data',
    beheer: 'Beheer',
    settings: 'Instellingen',
  },
}
